"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("stremio/core");
var common_1 = require("stremio/common");
var react_i18next_1 = require("react-i18next");
var useCastDevice = function (streamingUrl, session, video, playingOnExternalDevice) {
    var _a, _b;
    var core = (0, core_1.useCore)();
    var toast = (0, common_1.useToast)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var setPaused = video.setPaused;
    var intent = (0, react_1.useRef)(null);
    var extraTrack = video.state.extraSubtitlesTracks.find(function (_a) {
        var id = _a.id;
        return id === video.state.selectedExtraSubtitlesTrackId;
    });
    var track = extraTrack !== null && extraTrack !== void 0 ? extraTrack : video.state.subtitlesTracks.find(function (_a) {
        var id = _a.id;
        return id === video.state.selectedSubtitlesTrackId;
    });
    var trackUrl = (_a = track === null || track === void 0 ? void 0 : track.fallbackUrl) !== null && _a !== void 0 ? _a : track === null || track === void 0 ? void 0 : track.url;
    var subtitlesSrc = trackUrl && /^https?:\/\//i.test(trackUrl) ? trackUrl : null;
    var subtitlesDelay = extraTrack ? Math.round((_b = video.state.extraSubtitlesDelay) !== null && _b !== void 0 ? _b : 0) : 0;
    var subtitles = (0, react_1.useMemo)(function () { return ({ subtitlesSrc: subtitlesSrc, subtitlesDelay: subtitlesDelay }); }, [subtitlesSrc, subtitlesDelay]);
    var stop = (0, react_1.useCallback)(function () {
        core.transport.dispatch({ action: 'StreamingServer', args: { action: 'StopCasting' } });
    }, [core.transport]);
    var castToDevice = function (device) {
        var _a, _b, _c;
        if (!streamingUrl)
            return;
        intent.current = { device: device, resume: (_b = (_a = intent.current) === null || _a === void 0 ? void 0 : _a.resume) !== null && _b !== void 0 ? _b : video.state.paused === false };
        playingOnExternalDevice.current = true;
        video.setPaused(true);
        core.transport.dispatch({
            action: 'StreamingServer',
            args: {
                action: 'CastToDevice',
                args: { device: device, source: streamingUrl, time: Math.max(0, Math.round((_c = video.state.time) !== null && _c !== void 0 ? _c : 0)), subtitles: subtitles }
            }
        });
    };
    var stopBeforeLocalPlay = (0, react_1.useCallback)(function () {
        if (!intent.current)
            return false;
        intent.current.resume = true;
        stop();
        return true;
    }, [stop]);
    var isCasting = (0, react_1.useCallback)(function () { return intent.current !== null; }, []);
    (0, react_1.useEffect)(function () {
        if (session && intent.current && session.device === intent.current.device) {
            core.transport.dispatch({
                action: 'StreamingServer',
                args: { action: 'SetCastingSubtitles', args: { id: session.id, subtitles: subtitles } }
            });
        }
    }, [session === null || session === void 0 ? void 0 : session.id, subtitles]);
    (0, react_1.useEffect)(function () {
        var onEvent = function (name) {
            if (name === 'StoppedCasting' && intent.current) {
                var resume = intent.current.resume;
                intent.current = null;
                playingOnExternalDevice.current = false;
                if (resume)
                    setPaused(false);
            }
        };
        var onError = function (source, error) {
            if (intent.current && ['PlayingOnDevice', 'StoppedCasting', 'CastingSubtitlesChanged'].includes(source.event)) {
                console.error('Casting failed:', source.event, error);
                toast.show({ type: 'error', title: t('GENERIC_ERROR_MESSAGE'), timeout: 5000 });
            }
        };
        core.on('event', onEvent);
        core.on('error', onError);
        return function () {
            core.off('event', onEvent);
            core.off('error', onError);
        };
    }, [core, playingOnExternalDevice, setPaused, toast, t]);
    (0, react_1.useEffect)(function () { return function () {
        if (intent.current) {
            intent.current = null;
            playingOnExternalDevice.current = false;
            stop();
        }
    }; }, [streamingUrl, stop, playingOnExternalDevice]);
    return { castToDevice: castToDevice, stopBeforeLocalPlay: stopBeforeLocalPlay, isCasting: isCasting };
};
exports.default = useCastDevice;
